import { useState } from 'react';
import { Flex, Text, Button, Box, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { usePlots } from '../../../hooks/usePlots';
import { ConfirmationModal } from '../../../../lib/components';
import classes from '../../../shared/components/NewTable/NewTable.module.css';

export const BulkSelectionActions = ({
  selectedItems,
  data,
}: {
  selectedItems: string[];
  data: { id: string }[];
}) => {
  const { t } = useTranslation();
  const { deletePlots } = usePlots();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  return selectedItems.length ? (
    <>
      <Flex
        align="center"
        className={classes.selectedItems}
        justify="space-between"
      >
        <Text>
          {selectedItems.length} {t('plots.table.actions.selected')}
        </Text>
        <Tooltip label={t('plots.table.actions.delete.tooltip')}>
          <Button
            variant="outline"
            size="xs"
            onClick={() => setShowConfirmationModal(true)}
          >
            {t('common.delete')} ({selectedItems.length} / {data.length})
          </Button>
        </Tooltip>
      </Flex>
      <ConfirmationModal
        title={t('plots.table.actions.confirm.title').toString() + ':'}
        isOpen={showConfirmationModal}
        cancel={() => setShowConfirmationModal(false)}
        confirm={() => {
          setShowConfirmationModal(false);
          deletePlots.mutate(selectedItems);
        }}
        translation={{ cancel: 'common.cancel', delete: 'common.delete' }}
        disabled={deletePlots.isLoading}
      >
        {t('plots.table.actions.confirm.text', { count: selectedItems.length })}
      </ConfirmationModal>
    </>
  ) : null;
};
